export default __webpack_public_path__ + "static/media/aboutus-imgs.f8aa2e20.png";